<h3 class="text-center">
  {{ "WHERE_TO_WATCH" | translate }}
  <span class="text-primary">{{ getItemTranslation(item, "title") }}</span>
</h3>
@if (item | guardType: hasStreaming; as streamingWork) {
<div class="flex flex-wrap gap-2 sm:gap-3 justify-center items-start">
  @for ( streamingService of streamingOptions | slice: 0 : 8; track
  trackByStreamingOption(i, streamingService); let i = $index) {
  <div class="text-center">
    @if (streamingService.link) {
    <a [href]="streamingService.link" target="_blank" rel="noopener noreferrer">
      <app-display-streaming-option
        [streamingService]="streamingService"
        [userHasAccess]="isAvailableForUser(streamingService)"
      ></app-display-streaming-option>
    </a>
    } @else {
    <div>
      <app-display-streaming-option
        [streamingService]="streamingService"
        [userHasAccess]="isAvailableForUser(streamingService)"
      ></app-display-streaming-option>
    </div>
    }
  </div>
  }
</div>
<div
  class="legal-notice absolute bottom-2 pr-2 text-sm sm:text-base italic text-grey dark:text-borders-dark"
>
  <a
    class="external"
    [href]="
      streamingWork.streamingAvailability?.['fr']?.link ||
      'https://www.justwatch.com/'
    "
    target="_blank"
    rel="noopener noreferrer"
    >JustWatch</a
  >
  {{ "JUST_WATCH_ATTRIBUTION" | translate }}
</div>
}
